module.exports = __webpack_public_path__ + "fonts/e42bec93e3b68b69a46d94141abbce72.svg";